import React from "react";
import Chart from "react-apexcharts";
import styled from "styled-components";

export const ColumnChartSmall = () => {
  const options = {
    chart: {
      type: "bar",
      height: 350,
      stacked: true,
      toolbar: {
        show: true,
        tools: {
          download: false,
        },
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: "100%",
      },
    },
    colors: ["#008FFB", "#00E396"],
    dataLabels: {
      enabled: true,
      style: {
        colors: ["#fff"],
      },
      formatter: (val) => `${val}%`,
    },
    xaxis: {
      categories: [""],
      labels: {
        show: false,
      },
    },
    legend: {
      position: "top",
    },
  };
  const series = [
    {
      name: "Cuadrado",
      data: [31],
    },
    {
      name: "Rectángulo",
      data: [57],
    },
  ];

  return (
    <ChartColumnCard>
      <ChartTitle>Formatos</ChartTitle>
      <ContainerCharts>
        <Chart options={options} series={series} type="bar" height={125} />
      </ContainerCharts>
    </ChartColumnCard>
  );
};

const ChartColumnCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 25%;
  align-self: start;
  border-radius: 10px;
  margin-bottom: 60px;
  @media (max-width: 1200px) {
    align-self: center;
    width: 55%;
  }
`;
const ContainerCharts = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px;
  background-color: #ffffff;
`;
const ChartTitle = styled.h2`
  font-size: 1.2em;
  color: #333;
  text-align: center;
  font-family: "Roboto", sans-serif;
`;
